import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=d827d064&scoped=true&"
import script from "./Buscador.vue?vue&type=script&lang=js&"
export * from "./Buscador.vue?vue&type=script&lang=js&"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=d827d064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d827d064",
  null
  
)

export default component.exports